module.exports = __webpack_public_path__ + "static/img/Volume-z@2x.479bd07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/Volume-z@2x.png
// module id = Fc9u
// module chunks = 96